package ru.ontando.auth.web.util

fun <T> objectFromLambda(init: T.() -> Unit): T {

    val item: T = js("{}").unsafeCast<T>()
    init(item)
    return item

}